import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteAthlete, getAthleteSingle } from "../../../../services/athlete";
import { Athlete, emptyAthlete } from "../../../../interfaces/athlete";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminAthleteDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminAthleteDelete(props: AdminAthleteDeleteProps) {
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);

    const handleDelete = () => {
        deleteAthlete(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Athlete cannot be deleted. There is data related."));
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getAthleteSingle(props.id)
            .then(response => {
                setAthlete(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-athlete-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_athlete") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { athlete.id == 0 && 
                    <LoadingSpinner />
                }
                { athlete.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_athlete_message"
                                values={{
                                    athlete_name: athlete.name,
                                    athlete_email: athlete.email
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}